// src/components/Gallery.js
import React, { useState, useEffect } from 'react';
import '../css/Gallery.css'; // Link to the new CSS file

import { FaBed, FaBath, FaMapPin } from 'react-icons/fa'; // Icons (if needed for captions or future use)

// --- IMPORTANT: Import your actual images here ONE BY ONE ---
// Ensure these paths are correct relative to THIS file (Gallery.js)
// Example: if your images are in 'src/assets/gallery/', then paths would be like '../assets/gallery/image_name.jpg'

// Placeholder Imports (Replace these with your actual image imports)
// Make sure you have images for each category!
import imgBedroom1 from '../assets/gallery/bedroom1.jpeg';
import imgBedroom2 from '../assets/gallery/bedroom2.jpeg';
import imgBedroom3 from '../assets/gallery/bedroom3.jpeg'; // For example, a triple sharing room
import imgBedroom4 from '../assets/gallery/bedroom4.jpeg'; // For example, a triple sharing room
import imgBedroom5 from '../assets/gallery/bedroom5.jpeg'; // For example, a triple sharing room
import imgBedroom6 from '../assets/gallery/bedroom6.jpeg'; // For example, a triple sharing room
import imgBedroom7 from '../assets/gallery/bedroom7.jpeg'; // For example, a triple sharing room
import imgBedroom8 from '../assets/gallery/bedroom8.jpeg'; // For example, a triple sharing room
import imgBedroom9 from '../assets/gallery/bedroom9.jpeg'; // For example, a triple sharing room
import imgBedroom10 from '../assets/gallery/bedroom10.jpeg'; // For example, a triple sharing room
import imgBedroom11 from '../assets/gallery/bedroom11.jpeg'; // For example, a triple sharing room
import imgBedroom12 from '../assets/gallery/bedroom12.jpeg'; // For example, a triple sharing room
import imgBedroom13 from '../assets/gallery/bedroom13.jpeg'; // For example, a triple sharing room

import imgHall1 from '../assets/gallery/Hall1.jpeg'; // Could be a living room, lounge
import imgHall2 from '../assets/gallery/Hall2.jpeg';
import imgHall3 from '../assets/gallery/Hall2.jpeg';

import imgKitchen1 from '../assets/gallery/kitchen1.jpeg';
import imgKitchen2 from '../assets/gallery/kitchen2.jpeg';
import imgKitchen3 from '../assets/gallery/kitchen3.jpeg';
import imgKitchen4 from '../assets/gallery/kitchen4.jpeg';
import imgKitchen5 from '../assets/gallery/kitchen5.jpeg';

import imgWashroom1 from '../assets/gallery/washroom1.jpeg';
import imgWashroom2 from '../assets/gallery/washroom2.jpeg';
import imgWashroom3 from '../assets/gallery/Washroom3.jpeg';
import imgWashroom4 from '../assets/gallery/Washroom4.jpeg';

// Add more imports as needed for all your gallery images:
// import myCustomImage from '../assets/gallery/my_custom_image.jpg';


// Define your allImages array using the imported image variables
// Categorize them strictly as 'Hall', 'Kitchen', 'Washroom', 'Bed Room'
const allImages = [
  // --- BED ROOM Images ---
  { id: 1, src: imgBedroom1, category: 'Bed Room', alt: 'Spacious Single Bed Room' },
  { id: 2, src: imgBedroom2, category: 'Bed Room', alt: 'Comfortable Double Sharing Bed Room' },
  { id: 3, src: imgBedroom3, category: 'Bed Room', alt: 'Vibrant Double Sharing Bed Room' },
  { id: 4, src: imgBedroom4, category: 'Bed Room', alt: 'Vibrant Double Sharing Bed Room' },
  { id: 5, src: imgBedroom5, category: 'Bed Room', alt: 'Vibrant Double Sharing Bed Room' },
  { id: 6, src: imgBedroom6, category: 'Bed Room', alt: 'Vibrant Double Sharing Bed Room' },
  { id: 7, src: imgBedroom7, category: 'Bed Room', alt: 'Vibrant Double Sharing Bed Room' },
  { id: 8, src: imgBedroom8, category: 'Bed Room', alt: 'Vibrant Double Sharing Bed Room' },
  { id: 9, src: imgBedroom9, category: 'Bed Room', alt: 'Vibrant Double Sharing Bed Room' },
  { id: 10, src: imgBedroom10, category: 'Bed Room', alt: 'Vibrant Double Sharing Bed Room' },
  { id: 11, src: imgBedroom11, category: 'Bed Room', alt: 'Vibrant Double Sharing Bed Room' },
  { id: 12, src: imgBedroom12, category: 'Bed Room', alt: 'Vibrant Double Sharing Bed Room' },
  { id: 13, src: imgBedroom13, category: 'Bed Room', alt: 'Vibrant Double Sharing Bed Room' },

  // Add more Bed Room images as needed
  // { id: 4, src: yourBedRoomImage4, category: 'Bed Room', alt: 'Another Bed Room View' },

  // --- HALL Images ---
  { id: 14, src: imgHall1, category: 'Hall', alt: 'Cozy Common Hall Area' },
  // { id: 13, src: imgHall2, category: 'Hall', alt: 'Lounge and TV Area' },
  { id: 15, src: imgHall3, category: 'Hall', alt: 'Lounge and TV Area' },
  // Add more Hall images as needed
  // { id: 7, src: yourHallImage3, category: 'Hall', alt: 'Dining and Study Hall' },

  // --- KITCHEN Images ---
  { id: 16, src: imgKitchen1, category: 'Kitchen', alt: 'Well-Equipped Shared Kitchen' },
  { id: 17, src: imgKitchen2, category: 'Kitchen', alt: 'Clean & Hygienic Kitchenette' },
  { id: 18, src: imgKitchen3, category: 'Kitchen', alt: 'Clean & Hygienic Kitchenette' },
  { id: 19, src: imgKitchen4, category: 'Kitchen', alt: 'Clean & Hygienic Kitchenette' },
  { id: 20, src: imgKitchen5, category: 'Kitchen', alt: 'Clean & Hygienic Kitchenette' },
  // Add more Kitchen images as needed
  // { id: 10, src: yourKitchenImage3, category: 'Kitchen', alt: 'Modern Kitchen Appliances' },

  // --- WASHROOM Images ---
  { id: 21, src: imgWashroom1, category: 'Washroom', alt: 'Spotless Attached Washroom' },
  { id: 22, src: imgWashroom2, category: 'Washroom', alt: 'Spacious Common Washroom' },
  { id: 23, src: imgWashroom3, category: 'Washroom', alt: 'Spacious Common Washroom' },
  { id: 24, src: imgWashroom4, category: 'Washroom', alt: 'Spacious Common Washroom' },
  // Add more Washroom images as needed
  // { id: 13, src: yourWashroomImage3, category: 'Washroom', alt: 'Shower and Vanity Area' },
];

export default function Gallery() {
  const [filter, setFilter] = useState('All');
  const [filteredImages, setFilteredImages] = useState([]);
  const [selectedImage, setSelectedImage] = useState(null); // State for lightbox

  // Update filtered images whenever filter changes
  useEffect(() => {
    if (filter === 'All') {
      setFilteredImages(allImages);
    } else {
      setFilteredImages(allImages.filter(image => image.category === filter));
    }
  }, [filter]);

  // Get unique categories for filter buttons from your allImages array
  const categories = ['All', ...new Set(allImages.map(image => image.category))];

  // Open lightbox
  const openLightbox = (image) => {
    setSelectedImage(image);
  };

  // Close lightbox
  const closeLightbox = () => {
    setSelectedImage(null);
  };

  return (
    <div className="gallery-page-wrapper">
      {/* Hero Banner for Gallery */}
      <div className="gallery-banner">
        <h1>Our Gallery</h1>
        <p>Explore our comfortable and secure Girls' PG rooms and common areas.</p>
      </div>

      {/* Filter Buttons */}
      <div className="gallery-filters">
        {categories.map(category => (
          <button
            key={category}
            className={`filter-button ${filter === category ? 'active' : ''}`}
            onClick={() => setFilter(category)}
          >
            {category}
          </button>
        ))}
      </div>

      {/* Image Grid */}
      <div className="gallery-grid">
        {filteredImages.map(image => (
          <div key={image.id} className="gallery-item" onClick={() => openLightbox(image)}>
            <img src={image.src} alt={image.alt} loading="lazy" />
            <div className="image-overlay">
              <span>{image.alt}</span>
            </div>
          </div>
        ))}
      </div>

      {/* Lightbox/Modal for full image view */}
      {selectedImage && (
        <div className="lightbox-overlay" onClick={closeLightbox}>
          <div className="lightbox-content" onClick={e => e.stopPropagation()}> {/* Prevent closing when clicking image */}
            <button className="lightbox-close" onClick={closeLightbox}>&times;</button>
            <img src={selectedImage.src} alt={selectedImage.alt} />
            <p className="lightbox-caption">{selectedImage.alt}</p>
          </div>
        </div>
      )}
    </div>
  );
}